const BackArrow = ({ fill = "none" }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill= "none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99998 13.28L5.65331 8.93333C5.13998 8.42 5.13998 7.58 5.65331 7.06667L9.99998 2.72" stroke={fill} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export default BackArrow